import { useEffect, type FC } from 'react';
import { useIntl } from 'react-intl';

import type { CompaniesIndustry } from '@xing-com/crate-common-graphql-types';

import { IndustryCard } from '../../components/industry-card/industry-card';
import { SubpageLayout } from '../../components/layouts/subpage-layout';
import { useAllIndustries } from '../../hooks/use-companies-industries';
import { useTrackPage } from '../../hooks/use-track-page';
import { createCompaniesIndustries } from '../../models/industry';
import {
  pagesTrackingName,
  useNwtTrackingCompanies,
} from '../../utils/tracking';
import * as Styled from './industries.styles';

const SKELETON_CARDS_NUMBER = 24;

export const Industries: FC = () => {
  useTrackPage({ pageName: pagesTrackingName.industries });
  const { formatMessage } = useIntl();
  const { orderedIndustries, loading } = useAllIndustries();
  const trackNwtEvent = useNwtTrackingCompanies();

  const collection = (orderedIndustries ?? []) as CompaniesIndustry[];
  const industriesCollection = createCompaniesIndustries(collection);

  useEffect(() => {
    trackNwtEvent({
      eventSchema: 'basic',
      page: 'companies/industries',
      event: 'viewed_screen',
    });
  }, []);

  return (
    <SubpageLayout
      headerText={formatMessage({ id: 'CP_INDUSTRIES_SECTION_TITLE' })}
      description={formatMessage({ id: 'CP_INDUSTRIES_SECTION_SUBLINE' })}
    >
      <Styled.GridIndustries>
        {loading && (
          <>
            {Array.from({ length: SKELETON_CARDS_NUMBER }).map((_, index) => (
              <IndustryCard.Skeleton key={index} />
            ))}
          </>
        )}
        {industriesCollection.map((item) => (
          <IndustryCard
            key={item.id}
            item={item}
            trackingOptions={{
              eventSchema: 'basic',
              event: 'opened',
              page: 'companies/industries',
              itemUrn: `surn:x-xing:companies:industry:${item.seoName}`,
            }}
          />
        ))}
      </Styled.GridIndustries>
    </SubpageLayout>
  );
};
